module.exports = __webpack_public_path__ + "img/support.77e1a7f9.jpg";